import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { money } from "./rateMath";

const BreakdownBar = ({ result }) => {
  const labourPct = Math.round(result.labourShare * 1000) / 10;
  const overheadPct = result.total > 0 ? Math.round((100 - labourPct) * 10) / 10 : 0;
  const labourHr = result.annualBillableHours > 0 ? result.annualLabour / result.annualBillableHours : 0;
  const overheadHr = result.annualBillableHours > 0 ? result.annualOverhead / result.annualBillableHours : 0;
  return (
    <div data-testid="rate-calc-breakdown">
      <div className="text-xs font-medium text-slate-300 mb-2">What makes up each hour</div>
      <div className="flex h-3 w-full overflow-hidden rounded-full bg-slate-700">
        <div className="bg-pink-500 transition-[width] duration-500" style={{ width: `${labourPct}%` }} />
        <div className="bg-amber-400 transition-[width] duration-500" style={{ width: `${overheadPct}%` }} />
      </div>
      <div className="mt-2 flex flex-wrap justify-between gap-x-3 gap-y-1 text-[11px] text-slate-300">
        <span data-testid="rate-calc-breakdown-wages">
          <span className="inline-block w-2 h-2 rounded-full bg-pink-500 mr-1.5" />Wages {labourPct}% · {money(labourHr)}/hr
        </span>
        <span data-testid="rate-calc-breakdown-overhead">
          <span className="inline-block w-2 h-2 rounded-full bg-amber-400 mr-1.5" />Overhead {overheadPct}% · {money(overheadHr)}/hr
        </span>
      </div>
    </div>
  );
};

export const ResultsPanel = ({ result, marginPct, onApply }) => (
  <div className="rounded-xl bg-slate-900 text-white p-5 space-y-5 lg:sticky lg:top-4" data-testid="rate-calc-results">
    <div>
      <div className="text-xs uppercase tracking-wider text-slate-400">True Hourly Labour Cost</div>
      <div className="mt-1 font-mono text-4xl font-semibold" data-testid="rate-calc-true-hourly">
        {money(result.trueHourly)}<span className="text-lg text-slate-400">/hr</span>
      </div>
      <div className="text-[11px] text-slate-400 mt-1">
        Break-even across {Math.round(result.annualBillableHours).toLocaleString("en-AU")} billable hours a year
      </div>
    </div>
    <div className="rounded-lg bg-slate-800 p-4">
      <div className="text-xs text-slate-400">Suggested Labour Rate (with {marginPct}% margin)</div>
      <div className="mt-1 font-mono text-2xl font-semibold text-pink-300" data-testid="rate-calc-suggested-rate">
        {money(result.suggested)}/hr
      </div>
      <Button
        size="sm"
        onClick={() => onApply(result.suggested)}
        disabled={!(result.suggested > 0)}
        className="mt-3 h-9 text-xs bg-pink-600 hover:bg-pink-700"
        data-testid="rate-calc-apply-btn"
      >
        Apply as Labour Rate <ArrowRight className="w-3 h-3 ml-1.5" />
      </Button>
      <p className="text-[11px] text-slate-400 mt-2">Pre-fills the Labour Rate on the Pricing tab. Nothing changes until you save it there.</p>
    </div>
    <BreakdownBar result={result} />
  </div>
);
